import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';


export interface IPropsParkingSpotModel {
  id: string;
  type: string;
  name: string;
  status: string;
  icon?: Icon;
  markerPopupText: string;
  zone?: string;
  refDevice?: string;
  refParkingSite?: string;
  modifiedAt?: string;
  occupation?: number;
}

export interface IPropsUndergroundParkingSpotModel {
  id: string,
  type: string,
  availableSpotNumber: number,
  occupiedSpotNumber: number,
  occupiedSpotPercentage: number,
  totalSpotNumber: number,
  name: string

  icon?: Icon;

  markerPopupText: string;
}

export class ParkingSpotModel extends MarkerModelBase {
  static className = 'ParkingSpotModel';
  classProperties: IPropsParkingSpotModel;

  constructor(props: IPropsParkingSpotModel, geometry: IGeometryModel) {
    super(geometry, ParkingSpotModel.className);
    this.classProperties = props;
  }
}
export class UndergroundParkingSpotModel extends MarkerModelBase {
  static className = 'UndergroundParkingSpotModel';
  classProperties: IPropsUndergroundParkingSpotModel;

  constructor(props: IPropsUndergroundParkingSpotModel, geometry: IGeometryModel) {
    super(geometry, UndergroundParkingSpotModel.className);
    this.classProperties = props;
  }
}
